import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
    ApiBlueprint,
    discoveryApiRef,
    fetchApiRef
} from '@backstage/frontend-plugin-api';
import { isAmazonEcsServiceAvailable } from '../components/Router';
import { amazonEcsApiRef, AmazonEcsApiClient } from '../api';
import { rootRouteRef } from '../routes';

export const ecsEntityContentExtension = EntityContentBlueprint.make({
    name: 'ecs',
    params: {
        path: '/ecs',
        title: 'Amazon ECS',
        routeRef: rootRouteRef,
        filter: isAmazonEcsServiceAvailable,
        loader: async () =>
            import('../components/Router').then((m) =>
                <m.Router />
            ),
    },
});


export const amazonEcsApi = ApiBlueprint.make({
    name: 'ecs',
    params: (defineParams: any) =>
        defineParams({
            api: amazonEcsApiRef,
            deps: {
                discoveryApi: discoveryApiRef,
                fetchApi: fetchApiRef
            },
            factory: ({
                discoveryApi,
                fetchApi,
            }: any) =>
                new AmazonEcsApiClient({ discoveryApi, fetchApi }),
        }),
});